import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApprovedStatusIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 7.5,
			fill: "#1FB11C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4062 5.65039L6.45624 10.5999L4.46629 8.60992",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgApprovedStatusIcon);
export default ForwardRef;
